export default "__VITE_ASSET__pdLS4LRS__"